import React from 'react';
import { ReactComponent as PassportLogo } from '../svg/passport_logo.svg';
import { useSelector } from 'react-redux';

const ErrorPage404 = () => {
    const session = useSelector((state) => state.session);
    return (
        <div className="page-error p-4">
            {!session.isAuthenticated && <PassportLogo width="300" className="mb-5" />}
            <h1>Whoa! We know this page was here just a second ago!</h1>
            <p>
                Please <a href="mailto:?">contact us</a> for assistance and we'll work on getting this page up and
                running again.
            </p>
            <p>Thank you!</p>
        </div>
    );
};

export default ErrorPage404;
